module.exports = __webpack_public_path__ + "assets/media/fallback-company-logo.d74f1851.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fallback-company-logo.svg
// module id = 305
// module chunks = 0